import { createIcon } from "@chakra-ui/react";

const ArrowIcon = ` ${String.fromCodePoint(8594)}`;

const CheckmarkIcon = createIcon({
  displayName: "CheckmarkIcon",
  viewBox: "0 0 18 14",
  path: (
    <path
      fill="currentColor"
      d="M15.995.931c-.2598.0073-.5064.1081-.6875.2812l-10.293 9.5592-3.293-3.0582a1.005 1.005 0 00-.3246-.2093 1.0659 1.0659 0 00-.3866-.0762 1.0677 1.0677 0 00-.3882.0689 1.009 1.009 0 00-.3292.203.927.927 0 00-.2187.3058A.8711.8711 0 000 8.3659a.8727.8727 0 00.082.359.931.931 0 00.2254.3015l4 3.7149c.1875.1741.4418.2719.707.2719.2652 0 .5195-.0978.707-.2719l11-10.2158c.1445-.1305.2432-.2984.2832-.4819a.8684.8684 0 00-.0592-.5461c-.0786-.1724-.2114-.3187-.381-.4198a1.058 1.058 0 00-.5695-.1466z"
    />
  ),
});

const InfoIcon = createIcon({
  displayName: "InfoIcon",
  viewBox: "0 0 14 14",
  path: (
    <path
      fill="currentColor"
      d="M7.00016 0.000366211C3.32616 0.000366211 0.333496 2.99303 0.333496 6.66703C0.333496 10.341 3.32616 13.3337 7.00016 13.3337C10.6742 13.3337 13.6668 10.341 13.6668 6.66703C13.6668 2.99303 10.6742 0.000366211 7.00016 0.000366211ZM7.00016 1.3337C9.95358 1.3337 12.3335 3.71362 12.3335 6.66703C12.3335 9.62045 9.95358 12.0004 7.00016 12.0004C4.04675 12.0004 1.66683 9.62045 1.66683 6.66703C1.66683 3.71362 4.04675 1.3337 7.00016 1.3337ZM6.3335 3.3337V4.66703H7.66683V3.3337H6.3335ZM6.3335 6.00037V10.0004H7.66683V6.00037H6.3335Z"
    />
  ),
});

const ArrowRightIcon = createIcon({
  displayName: "ArrowRightIcon",
  viewBox: "0 0 18 14",
  path: (
    <path
      fill="currentColor"
      d="M11 0C10.7441 0 10.488 0.0994218 10.293 0.294922L10.207 0.380859C9.81603 0.771859 9.81603 1.40492 10.207 1.79492L14.0703 5.6582H1C0.448 5.6582 0 6.1062 0 6.6582C0 7.2102 0.448 7.6582 1 7.6582H14.0703L10.207 11.5215C9.81603 11.9125 9.81603 12.5455 10.207 12.9355L10.293 13.0215C10.684 13.4125 11.317 13.4125 11.707 13.0215L17.3633 7.36523C17.7543 6.97423 17.7543 6.34117 17.3633 5.95117L11.707 0.294922C11.5115 0.0994218 11.2559 0 11 0Z"
    />
  ),
});

const TrustPilotLogoIcon = createIcon({
  displayName: "TrustPilotLogoIcon",
  viewBox: "0 0 15 14",
  path: (
    <path
      fill="currentColor"
      d="M8.74006 5.09709H14.1526L9.79308 8.25613L7.09735 10.1937L2.71679 13.3527L4.38056 8.25613L0 5.09709H5.41252L7.07629 0.000488281L8.74006 5.09709ZM10.151 9.43213L7.07617 10.2109L11.4357 13.3892L10.151 9.43213Z"
    />
  ),
});

const EarthWithPlaneIcon = createIcon({
  displayName: "EarthWithPlaneIcon",
  viewBox: "0 0 40 40",
  path: (
    <path
      fill="currentColor"
      d="M15.9493 2.33137e-07C15.4246 0.000250233 14.9001 0.201563 14.5001 0.601563L11.6017 3.5L3.44932 1.14844L2.0001 2.60156L7.2501 7.85156L5.3751 9.72656L1.47276 8.42578L0.000100673 9.89844L8.09385 18L9.57041 16.5234L8.27354 12.625L10.1485 10.75L15.3946 15.9961L16.8478 14.5469L14.5001 6.39844L17.3985 3.5C18.1985 2.7 18.1985 1.40356 17.3985 0.601563C16.9975 0.200563 16.4741 -0.000249767 15.9493 2.33137e-07ZM23.8479 0.460256C22.8431 0.514295 22.0348 1.30638 21.9605 2.30988C21.8862 3.31339 22.569 4.21586 23.5549 4.41729C25.1409 4.77796 26.6312 5.38438 28.0002 6.1751V13.9993C28.0002 15.0993 28.9002 15.9993 30.0002 15.9993C31.1042 15.9993 32.0002 16.8953 32.0002 17.9993C32.0002 19.1033 31.1042 19.9993 30.0002 19.9993H24.0002C22.9002 19.9993 22.0002 20.8993 22.0002 21.9993V25.9993C22.0002 28.1993 23.8002 29.9993 26.0002 29.9993C27.1042 29.9993 28.0002 30.8953 28.0002 31.9993V33.8548C25.6474 35.2124 22.9215 35.9993 20.0002 35.9993C18.6148 35.9993 17.2807 35.8042 16.0002 35.4759V33.9993C16.0002 31.7993 14.2002 29.9993 12.0002 29.9993C10.8962 29.9993 10.0002 29.1033 10.0002 27.9993V25.9993C10.0002 24.8993 9.1002 23.9993 8.0002 23.9993H4.52364C4.19535 22.7188 4.0002 21.3847 4.0002 19.9993C4.0104 19.278 3.63145 18.6072 3.00846 18.2435C2.38546 17.8799 1.61494 17.8799 0.991947 18.2435C0.368951 18.6072 -0.00999971 19.278 0.000200864 19.9993C0.000200864 31.022 8.97753 39.9993 20.0002 39.9993C31.0229 39.9993 40.0002 31.022 40.0002 19.9993C40.0002 10.503 33.3503 2.53997 24.4455 0.514944C24.3149 0.483375 24.1814 0.465053 24.0471 0.460256C23.9807 0.456947 23.9142 0.456947 23.8479 0.460256Z"
    />
  ),
});

const CaretIcon = createIcon({
  displayName: "CaretIcon",
  viewBox: "0 0 12 7",
  path: (
    <path
      fill="currentColor"
      d="m5.6315 4.1315-3.821-3.821c-.414-.414-1.086-.414-1.5 0s-.414 1.086 0 1.5l4.614 4.614c.391.391 1.024.391 1.414 0l4.614-4.614c.414-.414.414-1.086 0-1.5s-1.086-.414-1.5 0z"
    />
  ),
});

const PlaneUpIcon = createIcon({
  displayName: "PlaneUpIcon",
  viewBox: "0 0 20 12",
  path: (
    <path
      fill="currentColor"
      d="M5.38375 0.000489806C5.29447 0.00323981 5.20392 0.0169585 5.11617 0.0434585C4.48017 0.236459 4.18852 0.971365 4.51852 1.54736L7.87203 7.39697L2.77828 8.74072L1.29391 7.49268C1.09091 7.32168 0.815486 7.26529 0.561486 7.34229C0.073486 7.48829 -0.149639 8.05463 0.108361 8.49463L1.39742 10.6938C1.85142 11.4678 2.7638 11.8457 3.6318 11.6177L18.3564 7.73877C18.3584 7.73812 18.3603 7.73747 18.3623 7.73682C19.0792 7.61076 19.6021 6.98817 19.6025 6.26026C19.6025 5.43183 18.9309 4.76026 18.1025 4.76026C17.9719 4.76028 17.8419 4.77735 17.7158 4.81104V4.80908L12.4853 6.18604L6.11813 0.27588C5.91638 0.0883804 5.6516 -0.00776019 5.38375 0.000489806Z"
    />
  ),
});

const HamburgerMenuIcon = createIcon({
  displayName: "HamburgerMenuIcon",
  viewBox: "0 0 24 13",
  path: (
    <>
      <rect width="24" height="3" rx="1.5" fill="currentColor" />
      <rect y="10" width="24" height="3" rx="1.5" fill="currentColor" />
    </>
  ),
});

const ClockIcon = createIcon({
  displayName: "ClockIcon",
  viewBox: "0 0 48 48",
  path: (
    <>
      <path
        fill="currentColor"
        d="M24 4C12.972 4 4 12.972 4 24C4 35.028 12.972 44 24 44C24.45 44 24.89 43.962 25.332 43.932C24.756 42.704 24.356 41.382 24.156 39.992C24.152 39.992 24.15 39.992 24.146 39.992C24.052 39.342 24 38.678 24 38C24 30.268 30.268 24 38 24C38.678 24 39.342 24.052 39.992 24.148C39.992 24.152 39.992 24.154 39.992 24.158C41.382 24.356 42.706 24.756 43.932 25.334C43.962 24.89 44 24.45 44 24C44 12.972 35.028 4 24 4ZM25.414 25.414L18.828 32C18.048 32.78 16.78 32.78 16 32C15.22 31.22 15.22 29.952 16 29.172L22 23.172V14C22 12.896 22.896 12 24 12C25.104 12 26 12.896 26 14V24C26 24.53 25.79 25.038 25.414 25.414Z"
      />
      <path
        fill="currentColor"
        d="M38 28C32.478 28 28 32.478 28 38C28 43.522 32.478 48 38 48C43.522 48 48 43.522 48 38C48 32.478 43.522 28 38 28ZM42 40H34C32.896 40 32 39.104 32 38C32 36.896 32.896 36 34 36H42C43.104 36 44 36.896 44 38C44 39.104 43.104 40 42 40Z"
      />
    </>
  ),
});

const CrossedPlaneIcon = createIcon({
  displayName: "CrossedPlaneIcon",
  viewBox: "0 0 48 48",
  path: (
    <>
      <path
        fill="currentColor"
        d="M18.86 20H10C10 20 10 20 7.24003 16.604C6.95003 16.248 6.67803 16 6.22003 16H5.00003C4.35003 16 3.87203 16.612 4.03003 17.242L6.00003 24L4.03003 30.758C3.87203 31.388 4.35003 32 5.00003 32H6.22003C6.67803 32 6.95003 31.752 7.24003 31.396C10 28 10 28 10 28H20.98L16.086 41.288C15.668 42.634 16.674 44 18.084 44C18.804 44 19.474 43.628 19.858 43.018L28.782 29.96L18.86 20ZM40 20H30L19.898 4.982C19.516 4.372 18.846 4 18.124 4C16.716 4 15.71 5.366 16.128 6.712L19.4 14.92L32.48 28H40C42.22 28 44 26.2 44 24C44 21.8 42.22 20 40 20Z"
      />
      <path
        fill="currentColor"
        d="M38 39.1721L8.82795 10.0001C8.04795 9.21807 6.78195 9.21807 5.99995 10.0001C5.21795 10.7821 5.21795 12.0481 5.99995 12.8281L35.172 42.0001C35.954 42.7821 37.2199 42.7821 38 42.0001C38.7799 41.2181 38.782 39.9521 38 39.1721Z"
      />
    </>
  ),
});

const PeopleIcon = createIcon({
  displayName: "PeopleIcon",
  viewBox: "0 0 36 48",
  path: (
    <path
      fill="currentColor"
      d="M18 0C16.9391 0 15.9217 0.421427 15.1716 1.17157C14.4214 1.92172 14 2.93913 14 4C14 5.06087 14.4214 6.07828 15.1716 6.82843C15.9217 7.57857 16.9391 8 18 8C19.0609 8 20.0783 7.57857 20.8284 6.82843C21.5786 6.07828 22 5.06087 22 4C22 2.93913 21.5786 1.92172 20.8284 1.17157C20.0783 0.421427 19.0609 0 18 0ZM20 10H16C12.686 10 10 12.686 10 16V32H12V38C12 39.104 12.896 40 14 40C15.104 40 16 39.104 16 38V32H20V38C20 39.104 20.896 40 22 40C23.104 40 24 39.104 24 38V32H26V16C26 12.686 23.314 10 20 10ZM8 0C6.93913 0 5.92172 0.421427 5.17157 1.17157C4.42143 1.92172 4 2.93913 4 4C4 5.06087 4.42143 6.07828 5.17157 6.82843C5.92172 7.57857 6.93913 8 8 8C9.06087 8 10.0783 7.57857 10.8284 6.82843C11.5786 6.07828 12 5.06087 12 4C12 2.93913 11.5786 1.92172 10.8284 1.17157C10.0783 0.421427 9.06087 0 8 0ZM28 0C26.9391 0 25.9217 0.421427 25.1716 1.17157C24.4214 1.92172 24 2.93913 24 4C24 5.06087 24.4214 6.07828 25.1716 6.82843C25.9217 7.57857 26.9391 8 28 8C29.0609 8 30.0783 7.57857 30.8284 6.82843C31.5786 6.07828 32 5.06087 32 4C32 2.93913 31.5786 1.92172 30.8284 1.17157C30.0783 0.421427 29.0609 0 28 0ZM0 14C0 14 0 24 0 26C0 28 2 28 2 28V38C2 39.104 2.896 40 4 40C5.104 40 6 39.104 6 38C6 38 6 28 6 26C6 24 4 24 4 24C4 24 4 16 4 15C4 14 5 14 5 14H6.202C6.506 12.514 7.166 11.168 8.05 10H4C1.79 10 0 11.79 0 14ZM32 10H27.95C28.834 11.168 29.496 12.514 29.798 14H31C31 14 32 14 32 15C32 16 32 24 32 24C32 24 30 24 30 26C30 28 30 38 30 38C30 39.104 30.896 40 32 40C33.104 40 34 39.104 34 38V28C34 28 36 28 36 26C36 24 36 14 36 14C36 11.79 34.21 10 32 10Z"
    />
  ),
});

const NumberOneIcon = createIcon({
  displayName: "NumberOneIcon",
  viewBox: "0 0 46 46",
  path: (
    <path
      d="M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46ZM17.8885 18.376L23.0005 14.68H25.5205V31H22.2805V18.64L19.4725 20.584L17.8885 18.376Z"
      fill="currentColor"
    />
  ),
});

const NumberTwoIcon = createIcon({
  displayName: "NumberTwoIcon",
  viewBox: "0 0 47 46",

  path: (
    <path
      d="M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46ZM24.673 24.6894C24.3277 24.8898 23.9736 25.0952 23.6153 25.312C23.3693 25.4625 23.1262 25.6057 22.8894 25.7452C21.5785 26.5173 20.4642 27.1736 20.1593 28.312H28.9913V31H16.7753V29.728C16.7753 26.164 19.1576 24.7075 21.4605 23.2995L21.6233 23.2C22.0246 22.955 22.4155 22.7316 22.7872 22.5191C24.5274 21.5243 25.8473 20.7699 25.8473 19.168C25.8473 17.848 24.8153 17.032 23.4233 17.032C21.8633 17.032 20.6873 17.944 19.1993 19.816L16.8233 18.136C18.4793 15.712 20.4473 14.272 23.3513 14.272C27.1433 14.272 29.0633 16.576 29.0633 19.12C29.0633 22.1425 27.0808 23.2926 24.673 24.6894Z"
      fill="currentColor"
    />
  ),
});

const NumberThreeIcon = createIcon({
  displayName: "NumberThreeIcon",
  viewBox: "0 0 47 46",
  path: (
    <path
      d="M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46ZM28.3388 17.32L23.8748 21.112C26.8028 21.232 28.9628 23.032 28.9628 25.984C28.9628 28.648 26.8748 31.408 22.8188 31.408C20.6348 31.408 18.8588 30.88 16.5308 29.296L18.0908 27.016C19.9388 28.144 21.1868 28.648 22.7228 28.648C24.6188 28.648 25.7228 27.592 25.7228 26.008C25.7228 24.376 24.4028 23.44 22.5548 23.44C21.5228 23.44 20.9228 23.632 20.6108 23.752L19.1948 21.808L24.4268 17.368H17.3708V14.68H28.3388V17.32Z"
      fill="currentColor"
    />
  ),
});

const PlusIcon = createIcon({
  displayName: "PlusIcon",
  viewBox: "0 0 16 16",
  path: (
    <path
      d="M15 7H9V1C9 0.448 8.552 0 8 0C7.448 0 7 0.448 7 1V7H1C0.448 7 0 7.448 0 8C0 8.552 0.448 9 1 9H7V15C7 15.552 7.448 16 8 16C8.552 16 9 15.552 9 15V9H15C15.552 9 16 8.552 16 8C16 7.448 15.552 7 15 7Z"
      fill="currentColor"
    />
  ),
});

const MinusIcon = createIcon({
  displayName: "MinusIcon",
  viewBox: "0 0 16 2",
  path: <rect width="16" height="2" rx="1" fill="currentColor" />,
});

const SideMenuIcon = createIcon({
  displayName: "SideMenuIcon",
  viewBox: "0 0 32 20",
  path: (
    <>
      <path
        d="M6.90002 7.49999C6.90002 6.89248 7.39251 6.39999 8.00002 6.39999H24C24.6075 6.39999 25.1 6.89248 25.1 7.49999C25.1 8.10751 24.6075 8.59999 24 8.59999H8.00002C7.39251 8.59999 6.90002 8.10751 6.90002 7.49999Z"
        fill="currentColor"
      />
      <path
        d="M8.00002 11.4C7.39251 11.4 6.90002 11.8925 6.90002 12.5C6.90002 13.1075 7.39251 13.6 8.00002 13.6H19C19.6075 13.6 20.1 13.1075 20.1 12.5C20.1 11.8925 19.6075 11.4 19 11.4H8.00002Z"
        fill="currentColor"
      />
      <path
        d="M0.900024 1.49999C0.900024 0.892481 1.39251 0.399994 2.00002 0.399994H30C30.6075 0.399994 31.1 0.892481 31.1 1.49999V18.5C31.1 19.1075 30.6075 19.6 30 19.6H2.00002C1.39251 19.6 0.900024 19.1075 0.900024 18.5V1.49999ZM3.10002 2.59999V17.4H28.9V2.59999H3.10002Z"
        fill="currentColor"
      />
    </>
  ),
});

const BlueInfoIcon = createIcon({
  displayName: "BlueInfoIcon",
  viewBox: "0 0 33 33",
  path: (
    <path
      d="M16.75 0.0266113C7.928 0.0266113 0.75 7.20461 0.75 16.0266C0.75 24.8486 7.928 32.0266 16.75 32.0266C25.572 32.0266 32.75 24.8486 32.75 16.0266C32.75 7.20461 25.572 0.0266113 16.75 0.0266113ZM18.75 7.02661C19.855 7.02661 20.75 7.92161 20.75 9.02661C20.75 10.1316 19.855 11.0266 18.75 11.0266C17.645 11.0266 16.75 10.1316 16.75 9.02661C16.75 7.92161 17.645 7.02661 18.75 7.02661ZM20.513 24.0726C18.694 24.7886 18.163 25.0266 16.995 25.0266C16.041 25.0266 15.299 24.7936 14.77 24.3286C13.725 23.4086 13.901 22.0806 14.228 20.7206L15.212 17.2376C15.402 16.5206 15.787 15.0556 15.248 14.5416C14.709 14.0276 13.454 14.3526 12.724 14.6246L12.987 13.5516C14.041 13.1226 15.373 12.5976 16.51 12.5976C18.22 12.5976 19.471 13.4526 19.471 15.0666C19.471 15.2176 19.453 15.4836 19.418 15.8656C19.352 16.5666 19.332 16.5206 18.24 20.3866C18.118 20.8116 17.929 21.7146 17.929 22.1516C17.929 23.8346 19.886 23.4186 20.776 22.9986L20.513 24.0726Z"
      fill="currentColor"
    />
  ),
});

const GraphIcon = createIcon({
  displayName: "GraphIcon",
  viewBox: "0 0 45 41",
  path: (
    <>
      <path
        d="M31.6665 40.6453H25.6665C25.4013 40.6453 25.1469 40.5399 24.9594 40.3524C24.7719 40.1648 24.6665 39.9105 24.6665 39.6453V29.6453C24.6665 29.38 24.7719 29.1257 24.9594 28.9382C25.1469 28.7506 25.4013 28.6453 25.6665 28.6453H31.6665C31.9317 28.6453 32.1861 28.7506 32.3736 28.9382C32.5611 29.1257 32.6665 29.38 32.6665 29.6453V39.6453C32.6665 39.9105 32.5611 40.1648 32.3736 40.3524C32.1861 40.5399 31.9317 40.6453 31.6665 40.6453Z"
        fill="currentColor"
      />
      <path
        d="M15.1955 7.53021C14.6485 7.14119 14.1705 6.66324 13.7815 6.11621L6.68151 13.2112C6.07281 12.8451 5.3768 12.6496 4.66651 12.6452C3.87538 12.6452 3.10202 12.8798 2.44422 13.3193C1.78643 13.7589 1.27374 14.3836 0.970988 15.1145C0.668237 15.8454 0.589024 16.6496 0.743365 17.4256C0.897705 18.2015 1.27867 18.9142 1.83808 19.4736C2.39749 20.033 3.11022 20.414 3.88614 20.5684C4.66207 20.7227 5.46633 20.6435 6.19724 20.3407C6.92814 20.038 7.55286 19.5253 7.99238 18.8675C8.43191 18.2097 8.66651 17.4363 8.66651 16.6452C8.66301 15.9332 8.46747 15.2354 8.10051 14.6252L15.1955 7.53021Z"
        fill="currentColor"
      />
      <path
        d="M16.6665 8.64526C18.8756 8.64526 20.6665 6.8544 20.6665 4.64526C20.6665 2.43612 18.8756 0.645264 16.6665 0.645264C14.4574 0.645264 12.6665 2.43612 12.6665 4.64526C12.6665 6.8544 14.4574 8.64526 16.6665 8.64526Z"
        fill="currentColor"
      />
      <path
        d="M40.6665 8.64526C42.8756 8.64526 44.6665 6.8544 44.6665 4.64526C44.6665 2.43612 42.8756 0.645264 40.6665 0.645264C38.4574 0.645264 36.6665 2.43612 36.6665 4.64526C36.6665 6.8544 38.4574 8.64526 40.6665 8.64526Z"
        fill="currentColor"
      />
      <path
        d="M39.1957 7.53021C38.6487 7.14119 38.1707 6.66324 37.7817 6.11621L30.6867 13.2112C30.0779 12.8411 29.3792 12.6453 28.6667 12.6453C27.9542 12.6453 27.2555 12.8411 26.6467 13.2112L19.5517 6.11621C19.1627 6.66324 18.6847 7.14119 18.1377 7.53021L25.2327 14.6302C24.8666 15.2389 24.6711 15.9349 24.6667 16.6452C24.6667 17.7061 25.0881 18.7235 25.8383 19.4736C26.5884 20.2238 27.6058 20.6452 28.6667 20.6452C29.7276 20.6452 30.745 20.2238 31.4951 19.4736C32.2453 18.7235 32.6667 17.7061 32.6667 16.6452C32.6632 15.9332 32.4677 15.2354 32.1007 14.6252L39.1957 7.53021Z"
        fill="currentColor"
      />
      <path
        d="M7.6665 40.6453H1.6665C1.40129 40.6453 1.14693 40.5399 0.959397 40.3524C0.771861 40.1648 0.666504 39.9105 0.666504 39.6453V29.6453C0.666504 29.38 0.771861 29.1257 0.959397 28.9382C1.14693 28.7506 1.40129 28.6453 1.6665 28.6453H7.6665C7.93172 28.6453 8.18607 28.7506 8.37361 28.9382C8.56115 29.1257 8.6665 29.38 8.6665 29.6453V39.6453C8.6665 39.9105 8.56115 40.1648 8.37361 40.3524C8.18607 40.5399 7.93172 40.6453 7.6665 40.6453Z"
        fill="currentColor"
      />
      <path
        d="M19.6665 40.6453H13.6665C13.4013 40.6453 13.1469 40.5399 12.9594 40.3524C12.7719 40.1648 12.6665 39.9105 12.6665 39.6453V17.6453C12.6665 17.38 12.7719 17.1257 12.9594 16.9382C13.1469 16.7506 13.4013 16.6453 13.6665 16.6453H19.6665C19.9317 16.6453 20.1861 16.7506 20.3736 16.9382C20.5611 17.1257 20.6665 17.38 20.6665 17.6453V39.6453C20.6665 39.9105 20.5611 40.1648 20.3736 40.3524C20.1861 40.5399 19.9317 40.6453 19.6665 40.6453Z"
        fill="currentColor"
      />
      <path
        d="M43.6665 40.6453H37.6665C37.4013 40.6453 37.1469 40.5399 36.9594 40.3524C36.7719 40.1648 36.6665 39.9105 36.6665 39.6453V17.6453C36.6665 17.38 36.7719 17.1257 36.9594 16.9382C37.1469 16.7506 37.4013 16.6453 37.6665 16.6453H43.6665C43.9317 16.6453 44.1861 16.7506 44.3736 16.9382C44.5611 17.1257 44.6665 17.38 44.6665 17.6453V39.6453C44.6665 39.9105 44.5611 40.1648 44.3736 40.3524C44.1861 40.5399 43.9317 40.6453 43.6665 40.6453Z"
        fill="currentColor"
      />
    </>
  ),
});

const PlaneWithClockIcon = createIcon({
  displayName: "PlaneWithClockIcon",
  viewBox: "0 0 40 38",
  path: (
    <path
      d="m27.675 17.066-5.3572-3.3475v-9.99906c0-.98646-.3919-1.93251-1.0894-2.63004-.6975-.697533-1.6436-1.0894-2.6301-1.0894-.9864 0-1.9325.391867-2.63 1.0894-.6975.69753-1.0894 1.64358-1.0894 2.63004v10.00036l-13.964064 8.7208c-.401056.2502-.697185.638-.8329493 1.0907-.1357647.4528-.1018585.9395.0953723 1.3691.19723.4296.544263.7725.976131.9647.43187.1921.91897.2203 1.37011.0792l12.3554-3.8484v9.9644l-3.0909 2.3116c-.2897.2166-.4956.5268-.5826.8779-.087.3512-.0498.7216.1053 1.0484s.4185.5899.7455.7445c.327.1547.6975.1914 1.0485.1039l5.4936-1.3743 3.3351.8338c-1.9798-2.1927-3.0746-5.0426-3.0722-7.9968-.0031-5.5073 3.7386-10.1572 8.8138-11.5433zm3.8342 2.3946c-.2262-.0167-.4537-.0254-.6818-.0254-1.5025-.0004-2.982.3682-4.3087 1.0735-1.3266.7052-2.4598 1.7255-3.2999 2.9711-.8401 1.2457-1.3614 2.6786-1.5181 4.1728-.1568 1.4943.0558 3.0042.6192 4.3971l.0055.0142c.717 1.7525 1.9555 3.2421 3.5477 4.2668 1.4764.9513 3.1961 1.4561 4.9524 1.4537 5.0602 0 9.1745-4.1156 9.1745-9.1746.0006-4.8297-3.7491-8.7983-8.4908-9.1492zm-.6832 15.267c-1.2089-.0005-2.3905-.3593-3.3956-1.0311-1.0055-.672-1.7891-1.6271-2.2518-2.7444-.4627-1.1174-.5837-2.3468-.3478-3.533.236-1.1861.8183-2.2756 1.6734-3.1308s1.9446-1.4377 3.1307-1.6738c1.1861-.236 2.4155-.1151 3.5329.3475s2.0725 1.2461 2.7447 2.2515c.6721 1.0054 1.031 2.1875 1.0314 3.3969-.0016 1.6221-.6468 3.1773-1.7939 4.3242-1.147 1.1467-2.7021 1.7916-4.324 1.793zm2.1566-8.4425-1.1307 2.1163 1.3124 1.3105c.16.1605.2689.3647.313.587s.0214.4527-.0653.662c-.0867.2094-.2334.3885-.4217.5146-.1882.1261-.4097.1936-.6363.1941-.0623-.0004-.1245-.0057-.1859-.0161-.2374-.0379-.4566-.1502-.6262-.3205l-1.9137-1.9106c-.1741-.1736-.2877-.3986-.3239-.6418-.0363-.2431.0066-.4915.1225-.7083l1.4878-2.7853.044-.0818c.1436-.2674.3871-.4672.6774-.5558.2903-.0887.6039-.0589.8724.0828.2434.1309.4316.3451.5301.6034.0984.2583.1006.5434.0061.8032-.0172.0501-.0379.099-.062.1463z"
      fill="currentColor"
    />
  ),
});

const icons = {
  CheckmarkIcon,
  InfoIcon,
  ArrowRightIcon,
  EarthWithPlaneIcon,
  CaretIcon,
  PlaneUpIcon,
  HamburgerMenuIcon,
  TrustPilotLogoIcon,
  ClockIcon,
  CrossedPlaneIcon,
  PeopleIcon,
  PlusIcon,
  MinusIcon,
  NumberOneIcon,
  NumberTwoIcon,
  NumberThreeIcon,
  SideMenuIcon,
  BlueInfoIcon,
  GraphIcon,
  PlaneWithClockIcon,
};

export {
  ArrowIcon,
  CheckmarkIcon,
  InfoIcon,
  ArrowRightIcon,
  EarthWithPlaneIcon,
  CaretIcon,
  PlaneUpIcon,
  HamburgerMenuIcon,
  TrustPilotLogoIcon,
  ClockIcon,
  CrossedPlaneIcon,
  PeopleIcon,
  PlusIcon,
  MinusIcon,
  NumberOneIcon,
  NumberTwoIcon,
  NumberThreeIcon,
  SideMenuIcon,
  BlueInfoIcon,
  GraphIcon,
  icons,
  PlaneWithClockIcon,
};

export type IconName = keyof typeof icons;
